import React, { useState, useEffect } from 'react';

const Dropdown = () => {
  const [bots, setBots] = useState<Bot[]>([]);
  const [templates, setTemplates] = useState<Template[]>([]);
  const [selectedBot, setSelectedBot] = useState<Bot>();
  const [selectedTemplate, setSelectedTemplate] = useState<Template>();
  const [selectedPhoneNumber, setSelectedPhoneNumber] = useState<PhoneNumber>();

  // Array com as opções de telefone fornecidas
  const phoneOptions = [
    {
      phoneNumberId: '109757298845360',
      phoneNumber: '+55 48 9172-8375',
      waba: '100780313086884',
    },
    {
      phoneNumberId: '25383842447389299',
      phoneNumber: '+55 13 98142-2302',
      waba: '2484909416771119',
    },
  ];

  const botApi = process.env.REACT_APP_BOT_API;
  const conversationApi = process.env.REACT_APP_CONVERSATION_API;
  const chatApi = process.env.REACT_APP_CHAT_API;

  useEffect(() => {
    // Buscar a lista de templates do endpoint
    fetch(`${botApi}/bot-templates`)
      .then((response) => response.json())
      .then((data) => {
        setTemplates(data);
      })
      .catch((error) => {
        console.error('Erro ao buscar bots:', error);
      });
  }, []);

  const handleBotChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const botId = event.target.value;
    const bot = bots.find((b) => b.id === botId);
    setSelectedBot(bot);
  };

  const handleTemplateChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const templateId = event.target.value;
    setSelectedTemplate(templates.find((t) => t.id === templateId));

    // Buscar bots pelo templateId selecionado
    fetch(`${botApi}/bot/template/${templateId}`)
      .then((response) => response.json())
      .then((data) => {
        setBots(data);
        // Resetar o bot selecionado ao mudar o template
        setSelectedBot(undefined);
      })
      .catch((error) => {
        console.error('Erro ao buscar bots pelo template:', error);
        setBots([]);
        setSelectedBot(undefined);
      });
  };

  const handlePhoneChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const phoneId = event.target.value;
    const phoneObj = phoneOptions.find((phone) => phone.phoneNumberId === phoneId);
    setSelectedPhoneNumber(phoneObj);
  };

  const handleIntegrate = async () => {
    if (!selectedBot || !selectedPhoneNumber) {
      alert('Selecione um bot e um telefone antes de integrar.');
      return;
    }

    const phoneId = selectedPhoneNumber.phoneNumberId;
    const headers = { 'Content-Type': 'application/json' };

    try {
      // === 1. BotIntegration ===
      const integrationRes = await fetch(`${botApi}/integration/whatsapp/${phoneId}`);
      if (!integrationRes.ok) throw new Error('Erro ao buscar integração');

      const botIntegration: BotIntegration = await integrationRes.json();
      const oldBotId = botIntegration.botId;

      botIntegration.botId = selectedBot.id;
      const updateIntegrationRes = await fetch(`${botApi}/integration`, {
        method: 'PUT',
        headers,
        body: JSON.stringify(botIntegration),
      });

      if (!updateIntegrationRes.ok) throw new Error('Erro ao atualizar integração');

      const updatedIntegration = await updateIntegrationRes.json();
      const integrationSuccess = updatedIntegration.botId === selectedBot.id;

      // === 2. ChannelConfig atual -> liberar channelId ===
      const currentConfigRes = await fetch(`${botApi}/config/channel/${phoneId}`);
      if (!currentConfigRes.ok) throw new Error('Erro ao buscar channelConfig atual');

      const currentChannelConfig: ChannelConfig = await currentConfigRes.json();
      const originalChannelId = currentChannelConfig.channelId;

      currentChannelConfig.channelId = "00000000";
      const updateCurrentRes = await fetch(`${botApi}/config/channel/${phoneId}`, {
        method: 'PUT',
        headers,
        body: JSON.stringify(currentChannelConfig),
      });

      if (!updateCurrentRes.ok) throw new Error('Erro ao liberar channelId antigo');
      const currentConfigSuccess = updateCurrentRes.ok;

      // === 3. ChannelConfig do novo bot -> atribuir novo channelId ===
      const newConfigRes = await fetch(`${botApi}/config/channel/${selectedBot.id}/bot`);
      if (!newConfigRes.ok) throw new Error('Erro ao buscar channelConfig do bot selecionado');

      const newChannelConfig: ChannelConfig = await newConfigRes.json();
      newChannelConfig.channelId = originalChannelId;

      const updateNewRes = await fetch(`${botApi}/config/channel/${originalChannelId}`, {
        method: 'PUT',
        headers,
        body: JSON.stringify(newChannelConfig),
      });

      if (!updateNewRes.ok) throw new Error('Erro ao atualizar channelConfig do novo bot');
      const newConfigSuccess = updateNewRes.ok;

      // === 4. Sucesso total ===
      if (integrationSuccess && currentConfigSuccess && newConfigSuccess) {
        const cacheCleanResults: string[] = [];

        if (oldBotId && oldBotId !== selectedBot.id) {
          const res = await fetch(`${botApi}/integration/bot/${oldBotId}/clean`, {
            method: 'POST',
          });
          cacheCleanResults.push(`Cache do bot antigo (${oldBotId}): ${res.ok ? 'limpo' : 'falha'}`);
        }

        const [newBotClean, chatCache, conversationCache] = await Promise.all([
          fetch(`${botApi}/integration/bot/${selectedBot.id}/clean`, { method: 'POST' }),
          fetch(`${chatApi}/clearCache`, { method: 'POST' }),
          fetch(`${conversationApi}/api/v1/cache/clearAll`, { method: 'POST' }),
        ]);

        cacheCleanResults.push(
          `Cache do bot atual (${selectedBot.id}): ${newBotClean.ok ? 'limpo' : 'falha'}`,
          `Cache do Chat API: ${chatCache.ok ? 'limpo' : 'falha'}`,
          `Cache do Conversation API: ${conversationCache.ok ? 'limpo' : 'falha'}`
        );

        alert(
          `Integração e ChannelConfig migradas com sucesso!\n\nResultado da limpeza de cache:\n- ${cacheCleanResults.join('\n- ')}`
        );
      } else {
        alert('Falha em alguma etapa da integração. Cache não limpo.');
      }

    } catch (error) {
      console.error('Erro na integração:', error);
      if (error instanceof Error) {
        alert('Erro ao integrar: ' + error.message);
      } else {
        alert('Erro ao integrar: erro desconhecido');
      }
    }
  };


  return (
    <>
      <div className="flex flex-col items-center justify-center min-h-screen bg-blue-100">

        <h1 className="w-full text-center text-5xl font-extrabold text-indigo-700 mb-12">
          Escolha suas opções
        </h1>
        <div className="mx-auto w-[70vw] grid grid-cols-4 justify-center items-center bg-white rounded-lg shadow-md">

          <div className="p-6">
            <label htmlFor="template">Template</label>
            <select
              id="template"
              className="form-select"
              value={selectedTemplate?.id || ''}
              onChange={handleTemplateChange}
            >
              <option value="" disabled>
                Escolha um Template
              </option>
              {templates.map((template) => (
                <option key={template.id} value={template.id}>
                  {template.nameTemplate}
                </option>
              ))}
            </select>
          </div>
          <div className="p-6">
            <label htmlFor="bot">Bot</label>
            <select
              id="bot"
              className="form-select"
              value={selectedBot?.id || ''}
              onChange={handleBotChange}
            >
              <option value="" disabled>
                Escolha um bot
              </option>
              {bots.map((bot) => (
                <option key={bot.id} value={bot.id}>
                  {bot.botName}
                </option>
              ))}
            </select>
          </div>
          <div className="p-6">
            <label htmlFor="telefone">Telefone</label>
            <select
              id="telefone"
              className="form-select"
              value={selectedPhoneNumber?.phoneNumberId || ''}
              onChange={handlePhoneChange}
            >
              <option value="" disabled>
                Escolha um telefone
              </option>
              {phoneOptions.map((phone) => (
                <option key={phone.phoneNumberId} value={phone.phoneNumberId}>
                  {phone.phoneNumber}
                </option>
              ))}
            </select>
          </div>
          <div className="flex flex-col items-center justify-center p-6">
            <button
              className="w-full bg-indigo-600 text-white font-semibold py-3 rounded-md hover:bg-indigo-700 transition"
              disabled={!selectedBot?.id || !selectedPhoneNumber?.phoneNumberId || !selectedTemplate?.id}
              onClick={handleIntegrate}
            >
              Integrar
            </button>
          </div>
          {selectedBot && (
            <p className="col-span-4 text-center mt-2">
              Bot Selecionado: {selectedBot?.botName} id: {selectedBot?.id}
            </p>
          )}
          {selectedTemplate && (
            <p className="col-span-4 text-center mt-2">
              Template Selecionado: {selectedTemplate.nameTemplate} id: {selectedTemplate.id}
            </p>
          )}
          {selectedPhoneNumber?.phoneNumberId && (
            <p className="col-span-4 text-center mt-2">
              Telefone Selecionado: {selectedPhoneNumber?.phoneNumber} phoneNumberId: {selectedPhoneNumber?.phoneNumberId}
            </p>
          )}
        </div>
      </div>

    </>

  );
};


export default Dropdown;
